import React from "react";
import ReactDOM from "react-dom/client";
import "@fontsource/cormorant-garamond/latin-400.css";
import "@fontsource/cormorant-garamond/latin-ext-400.css";
import "@fontsource/cormorant-garamond/latin-500.css";
import "@fontsource/cormorant-garamond/latin-ext-500.css";
import "@fontsource/cormorant-garamond/latin-600.css";
import "@fontsource/cormorant-garamond/latin-ext-600.css";
import "@fontsource/cormorant-garamond/latin-500-italic.css";
import "@fontsource/cormorant-garamond/latin-ext-500-italic.css";
import "@fontsource/dm-sans/latin-400.css";
import "@fontsource/dm-sans/latin-ext-400.css";
import "@fontsource/dm-sans/latin-500.css";
import "@fontsource/dm-sans/latin-ext-500.css";
import "@fontsource/dm-sans/latin-600.css";
import "@fontsource/dm-sans/latin-ext-600.css";
import "@fontsource/noto-serif-devanagari/devanagari-400.css";
import App from "./App";
import "./style.css";

const container = document.getElementById("root")!;
const pageConfig=document.getElementById("library-page-config");
const page=pageConfig?JSON.parse(pageConfig.textContent||"null"):undefined;
const sharedDemo=document.documentElement.dataset.sharedReviewDemo==="true";
const learningPage=document.documentElement.dataset.learningApps==="true";
const coursesPage=document.documentElement.dataset.courses==="true";
const application = (
  <React.StrictMode>
    <App sharedDemo={sharedDemo} page={page} learningPage={learningPage} coursesPage={coursesPage}/>
  </React.StrictMode>
);

// Production already contains the readable page; attach its interactions.
// Vite's development HTML starts empty and uses a regular client render.
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, application);
} else {
  ReactDOM.createRoot(container).render(application);
}
